import React from 'react';
import PropTypes from 'prop-types';

const getClassName = (className) => `btn ${className || 'btn-default'}`;

const createButtonType = (className, disabled, onClick, text) => (
  React.createElement('button', {
    className: getClassName(className),
    disabled,
    type: 'button',
    onClick
  }, text)
);

const createSubmitType = (className, disabled, onClick, text) => (
  React.createElement('button', {
    className: getClassName(className),
    disabled,
    type: 'submit',
    onClick
  }, text)
);

const Button = ({
  className, disabled, onClick, text, type
}) => (
  type === 'button' ? createButtonType(className, disabled, onClick, text)
    : createSubmitType(className, disabled, onClick, text)
);

Button.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  type: PropTypes.string
};

Button.defaultProps = {
  className: 'btn btn-default',
  disabled: false,
  onClick: () => {},
  text: 'Button',
  type: 'button'
};

export default Button;
